// extracted by mini-css-extract-plugin
export default {"content":"uQ-z","lookName":"vQ-z","shopTheLookContainer":"wQ-z","productContainer":"xQ-z","imageContainer":"yQ-z","mainImage":"zQ-z"};